export const getFirebaseToken = async (messaging) => {
  try {
    const fcm_token = await messaging.getToken({
      vapidKey:
        "BM0xKbdFzAys_MvXGnA7hSAUE38lrkJ8VaySOWXYDRuoTnJicK5N3iHtC9nhsoKluYaawgNpf-vcp6U3P9lLWAE",
    });

    return fcm_token;
  } catch (err) {
    console.log("error getting the token", err);
    return undefined;
  }
};
